import reporter from "../report/reporter";
import { getPage } from "../shared/global";
import { getAttribute } from "./get";

export function questionnaire_expose(targetNode) {
  const page = getPage();
  const { page_nm, sub_page_nm } = page;
  const trackData = {
    event_id: 39029,
    event_name: "questionnaire_expose",
    subject_name: getAttribute(targetNode, "data-subject-name"),
    questionnaire_id: getAttribute(targetNode, "data-questionnaire-id"),
    questionnaire_title: getAttribute(targetNode, "data-questionnaire-title"),
    questionnaire_type: getAttribute(targetNode, "data-questionnaire-type"),
    post_page: getAttribute(targetNode, "data-post-page"),
    create_id: getAttribute(targetNode, "data-create-id"),
    create_title: getAttribute(targetNode, "data-create-title"),
    page_name: `${page_nm}${sub_page_nm ? `-${sub_page_nm}` : ""}`,
    ...page,
  };

  var source = getAttribute(targetNode, "data-content-source");

  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  reporter(trackData);
}

export function questionnaire_click(targetNode) {
  const page = getPage();
  const { page_nm, sub_page_nm } = page;
  const trackData = {
    event_id: 39028,
    event_name: "questionnaire_click",
    subject_name: getAttribute(targetNode, "data-subject-name"),
    questionnaire_id: getAttribute(targetNode, "data-questionnaire-id"),
    questionnaire_title: getAttribute(targetNode, "data-questionnaire-title"),
    questionnaire_type: getAttribute(targetNode, "data-questionnaire-type"),
    post_page: getAttribute(targetNode, "data-post-page"),
    click_type: getAttribute(targetNode, "data-click-type"),
    file_ids: getAttribute(targetNode, "data-file-ids")?.split(","),
    distcodes: getAttribute(targetNode, "data-distcodes")?.split(","),
    primary_filter_title: getAttribute(targetNode, "data-primary-filter-title"),
    second_filter_title: getAttribute(targetNode, "data-second-filter-title"),
    third_filter_title: getAttribute(targetNode, "data-third-filter-title"),
    satisfaction_degree: getAttribute(targetNode, "data-satisfaction-degree"),
    feedback_content: getAttribute(targetNode, "data-feedback-content"),
    feedback_type: getAttribute(targetNode, "data-feedback-type"),
    create_id: getAttribute(targetNode, "data-create-id"),
    create_title: getAttribute(targetNode, "data-create-title"),
    search_word: getAttribute(targetNode, "data-search-word"),
    page_name: `${page_nm}${sub_page_nm ? `-${sub_page_nm}` : ""}`,
    ...page,
  };
  var source = getAttribute(targetNode, "data-content-source");

  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  if (trackData.click_type === "提交") {
    Object.assign(trackData, {
      questionnaire_score: getAttribute(targetNode, "data-questionnaire-score"),
      options_title: getAttribute(targetNode, "data-options-title"),
    });
  }

  reporter(trackData);
}
